import * as ReactDOM from 'react-dom';

import { MountPoints } from '../constants/portalLocationConstants';
import BaseComponent from './BaseComponent';

interface Props {
  children?: React.ReactNode;
  isOpen?: boolean;
  mountLocation?: MountPoints;
}

const mountLocationMapping = {
  [MountPoints.body]: 'body',
  [MountPoints.root]: '#Root',
};

export default class Portal extends BaseComponent<Props> {
  wrapper: HTMLDivElement | undefined;

  mountModal(props: Props) {
    const mountNode = this.mountNode(props);

    this.wrapper = document.createElement('div');
    this.wrapper.classList.add('Portal');
    mountNode.appendChild(this.wrapper);
  }

  mountNode(props: Props) {
    const mountLocation = props.mountLocation || MountPoints.body;
    const mountLocationSelector = mountLocationMapping[mountLocation] || MountPoints.body;

    const mountNode = document.querySelector(mountLocationSelector);
    if (!mountNode) {
      throw new Error(`Cannot find the mount point ${mountLocationSelector}`);
    }

    return mountNode;
  }

  unmountModal() {
    if (this.wrapper) {
      const mountNode = this.mountNode(this.props);
      mountNode.removeChild(this.wrapper);
      delete this.wrapper;
      this.wrapper = undefined;
    }
  }

  componentWillUnmount() {
    this.unmountModal();
  }

  render() {
    const { children, isOpen: isOpenFromProps } = this.props;
    const isOpen = isOpenFromProps || false;

    if (BROWSER) {
      if (!this.wrapper && isOpen) {
        this.mountModal(this.props);
      } else if (this.wrapper && !isOpen) {
        this.unmountModal();
      }
    }

    if (!isOpen) {
      return null;
    }

    if (this.wrapper) {
      return ReactDOM.createPortal(children, this.wrapper);
    }

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return children!;
  }
}
